<template>
  <div class="card">
    <div class="card-header">
      <h5>Booking Customer Detail Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Departure Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="departure_from_date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="departure_from.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :max-date="departure_to.date"
              />
              <small class="text-danger" v-if="errors.departure_from">{{ errors.departure_from }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="departure_to_date"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="departure_to.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :min-date="departure_from.date"
              />
              <small class="text-danger" v-if="errors.departure_to">{{ errors.departure_to }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Booking Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="From Date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="booking_from.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                />
                <small class="text-danger" v-if="errors.booking_from">{{ errors.booking_from }}</small>
              </div>
            </div>
            <div class="col-md-6">
              <div>
                <dateTimePicker
                  no-label
                  label="To Date"
                  id="booking_date"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  v-model="booking_to.date"
                  :only-date="true"
                  button-color="#ec391e"
                  color="#ec391e"
                  style="border: 1px solid #DFE5F9"
                  :min-date="booking_from.date"
                />
                <small class="text-danger" v-if="errors.booking_to">{{ errors.booking_to }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-6">
          <label class="form-label">
            Tour name
          </label>
          <v-select
            v-if="tours !== null"
            v-model="selectedTour"
            label="name"
            class="v-select--medium"
            :options="tours"
            placeholder="Filter by tour"
          >
            <template #search="{attributes, events}">
              <input
                class="vs__search"
                :required="!selectedTour"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
          
        </div>
        <div class="col-md-6">
          <label for="checkbox" class="form-label">Unaccepted Bookings Only</label>
          <br>
          <label class="switch">
            <input v-model="unaccepted_only" id="checkbox" type="checkbox"/>
            <span class="switch__slider"></span>
          </label>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6">
          <div class="customer-filter">
            <label>Customer Filter</label>
            <div class="filter-mode">
              <div class="radio-group">
                <label class="radio">
                  <input 
                    type="radio" 
                    v-model="filterMode" 
                    value="all" 
                    name="filterMode"
                  >
                  <span>Show All Customers</span>
                </label>
                
                <label class="radio">
                  <input 
                    type="radio" 
                    v-model="filterMode" 
                    value="exclude" 
                    name="filterMode"
                  >
                  <span>Exclude Selected Types</span>
                </label>
                
                <label class="radio">
                  <input 
                    type="radio" 
                    v-model="filterMode" 
                    value="only" 
                    name="filterMode"
                  >
                  <span>Show Only Selected Types</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <template v-if="filterMode == 'exclude'">
                <label for="checkbox" class="form-label">Exclude Customers</label>
                <v-select
                  label="name"
                  v-model="excludedCustomerOptions"
                  class="v-select--medium"
                  :options="[{
                    slug: 'blacklisted',
                    name: 'Blacklisted'
                  },
                  {
                    slug: 'opt_out_mailing',
                    name: 'Opt Out of Mailing'
                  },
                  {
                    slug: 'opt_out_email',
                    name: 'Opt Out Email'
                  }
                  ]"
                  placeholder="Exclude Customers"
                  multiple
                >
                </v-select>
              </template>
              <template v-if="filterMode == 'only'">
                <label for="checkbox" class="form-label">Only Customers</label>
                <v-select
                  label="name"
                  v-model="onlyCustomerOptions"
                  class="v-select--medium"
                  :options="[{
                    slug: 'blacklisted',
                    name: 'Blacklisted'
                  },
                  {
                    slug: 'opt_out_mailing',
                    name: 'Opt Out of Mailing'
                  },
                  {
                    slug: 'opt_out_email',
                    name: 'Opt Out Email'
                  }
                  ]"
                  placeholder="Only Customers"
                  multiple
                >
                </v-select>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button
        type="submit"
        class="button"
        v-on:click.prevent="getDepartureBookingReport"
      >
        Generate report
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "CustomerDetailReport",
  data() {
    return {
      departure_from: {},
      departure_to: {},
      booking_from: {},
      booking_to: {},
      errors: {
        departure_from:null,
        departure_to:null,
        booking_from:null,
        booking_to:null
      },
      selectedTour: null,
      unaccepted_only: false,
      excludedCustomerOptions: [],
      onlyCustomerOptions: [],
      filterMode: 'all',
    };
  },
  props:{
    tours:Object
  },
  watch: {
    filterMode(newMode) {
      if (newMode === 'all') {
        this.excludedCustomerOptions =  [];
        this.onlyCustomerOptions =  [];
      } else if (newMode === 'exclude') {
        this.onlyCustomerOptions =  [];
      }else if (newMode === 'only') {
        this.excludedCustomerOptions =  [];
      }
    }
  },
  methods: {
    getDepartureBookingReport() {
      this.validateFields()
          .then((response) => {
            if (response) {
              this.$store.dispatch("setLoadStatus");
                const request = {
                departure_from_date: this.departure_from.date,
                departure_to_date: this.departure_to.date,
                tour_id : (this.selectedTour) ? this.selectedTour.id : null,
                unaccepted_only: this.unaccepted_only,
                booking_from_date: this.booking_from.date,
                booking_to_date: this.booking_to.date,
                filterMode:this.filterMode,
                excluded_customer :(this.excludedCustomerOptions) ? this.excludedCustomerOptions.map((element) => element.slug) : [],
                only_customer :(this.onlyCustomerOptions) ? this.onlyCustomerOptions.map((element) => element.slug) : []
              }
              fetch(this.$api + 'reports/departure-customer-details', {
                method: 'POST',
                body: JSON.stringify(request),
                headers:{
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': localStorage.getItem('token')
                }
              })
              .then((res) => {
                if(res.status === 200) {
                  this.$store.dispatch('setLoadStatus')
                  res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', 'Departure-Report.xlsx')
                    document.body.appendChild(link)
                    link.click();
                  })
                } else {
                  this.$store.dispatch('setLoadStatus')
                  Promise.race([res.json()])
                  .then(response => {
                    if(response.message) {
                      this.$notify({
                        type: 'error',
                        title: response.message
                      });
                    } else {
                      this.$notify({
                        type: 'error',
                        title: response.error
                      });
                    }
                  })
                }
              })
              
            }
          })
          .catch(error => console.log(error))
    },
    validateFields(){

      let This = this

      return new Promise((resolve, reject) => {

        let errorCount = 0;
        This.errors = {
          departure_from:null,
          departure_to:null
        }
        // Booking Dates validation
        // if(!This.departure_from.date){
        //   This.errors.departure_from = "Please select a valid departure from date"
        //   errorCount +=1
        // }else if(This.departure_from.date && !This.departure_to.date){
        //   This.errors.departure_to = "Please select a valid departure to date"
        //   errorCount +=1
        // }else{
        //   This.errors.departure_from = null
        //   This.errors.departure_to = null
        // }

        resolve(true)
        // if(errorCount == 0 ){
        // }else{
        //   reject(true)
        // }

      })
    }
  }
};
</script>
<style scoped>
.filter-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.filter-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.date-filters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.date-range {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.date-range input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tour-select select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.toggle-section {
  display: flex;
  align-items: center;
}

.toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}

.toggle-slider {
  position: relative;
  width: 40px;
  height: 20px;
  background: #ddd;
  border-radius: 20px;
  transition: 0.3s;
}

.toggle-slider:before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: 0.3s;
}

.toggle input:checked + .toggle-slider {
  background: #4CAF50;
}

.toggle input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

.toggle input {
  display: none;
}

.customer-filter {
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.filter-mode {
  margin: 15px 0;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.radio {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.selected-types {
  margin-top: 15px;
}

.type-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.tag {
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

label {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

input[type="date"],
select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

input[type="date"]:focus,
select:focus {
  outline: none;
  border-color: #1976d2;
}

@media (max-width: 768px) {
  .date-filters {
    grid-template-columns: 1fr;
  }
  
  .filter-container {
    padding: 15px;
  }
}
</style>